import { render, staticRenderFns } from "./ListView.vue?vue&type=template&id=22c8f39c"
import script from "@/views/modules/WorkPackages/js/ListView.js?vue&type=script&lang=js&external"
export * from "@/views/modules/WorkPackages/js/ListView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports